export interface DurationOption {
  label: string;
  value: number;
}

function formatDurationOptionLabel(minutes: number): string {
  if (minutes < 60) return `${minutes} minutes`;
  const hours = minutes / 60;
  return hours === 1 ? '1 hour' : `${hours} hours`;
}

export const DURATIONS: DurationOption[] = Array.from({ length: 48 }, (_, i) => {
  const minutes = (i + 1) * 30;
  return { label: formatDurationOptionLabel(minutes), value: minutes };
});
